
export default function(state=null,action){
    switch (action.type) {
      case "NOTIFY_REASONS":
          return action.payload;
      default: return state;
    }
  }
 
  


// WEBPACK FOOTER //
// ./src/reducer/get_notify_reason.js